import { useState, useEffect } from 'react';
import * as Cookies from 'js-cookie';
import { COOKIE_CONSENT_KEY, EMPTY_CONSENT } from './constants';
import { allCookiesSetToValue, allPropsApproved } from './utils';
export const useCookieConsent = (options) => {
    const initialConsent = Cookies.getJSON(COOKIE_CONSENT_KEY) ||
        (options === null || options === void 0 ? void 0 : options.defaultConsent) ||
        EMPTY_CONSENT;
    const [consent, setConsent] = useState(initialConsent);
    useEffect(() => {
        if (consent === null || consent === void 0 ? void 0 : consent.necessary) {
            Cookies.set(COOKIE_CONSENT_KEY, consent, options === null || options === void 0 ? void 0 : options.consentCookieAttributes);
        }
    }, [consent]);
    const acceptCookies = (newConsent) => {
        setConsent(newConsent);
    };
    const declineAllCookies = () => {
        setConsent(allCookiesSetToValue(false));
    };
    const acceptAllCookies = () => {
        setConsent(allCookiesSetToValue(true));
    };
    const didAcceptAll = () => {
        const keyArray = Object.keys(consent || {});
        return keyArray.reduce((prev, key) => (prev && consent && consent[key]) || false, true);
    };
    const didDeclineAll = opts => {
        const keyArray = Object.keys(consent || {});
        return keyArray.reduce((prev, key) => {
            if (!(opts === null || opts === void 0 ? void 0 : opts.includingNecessary) && key === 'necessary')
                return prev;
            return (prev && consent && !consent[key]) || false;
        }, true);
    };
    const cookieWrapper = {
        set: (name, value, props, options) => {
            if (!allPropsApproved(props, consent))
                return undefined;
            return Cookies.set(name, value, options);
        },
        get: Cookies.get,
        getAll: Cookies.get,
        getJSON: Cookies.getJSON,
        getAllJSON: Cookies.getJSON,
        remove: Cookies.remove,
    };
    return {
        consent,
        acceptCookies,
        declineAllCookies,
        acceptAllCookies,
        didAcceptAll,
        didDeclineAll,
        cookies: cookieWrapper,
    };
};
//# sourceMappingURL=useCookieConsent.js.map